import {observer} from 'mobx-react-lite';
import {Globe} from 'react-feather';
import {countryFlag} from '@/utils/countries';
import React from 'react';
import styled from 'styled-components';
import {useStore} from '@/store/root-store';
import {SkeletonRingLoader} from '@/components/common-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {Tooltip} from 'antd';
import {formatLargeNumber, formatNumber} from '@/utils/number';
import {EmptyStateKeDetail} from './emptyStateKe';

interface Props {
  className?: string;
}

export const GlobalVolume: React.FC<Props> = observer(({className=''}: Props) => {
  const {countries: {getSpecificCountryByCode}, keywordResearcherV2: {keywordDetails: {getSvTopCountries, loadingSvCountriesDetails}}} = useStore('');
  const getSvTopSortCountries = getSvTopCountries?.slice()?.sort((a, b) => a.searchVolume < b.searchVolume ? 1 : -1 );

  const getTrafficPercentage = value=> {
    const totalValue = getSvTopSortCountries[0]?.searchVolume;
    if (totalValue == value) {
      return 100;
    } else {
      const prcentage = value/totalValue * 100;
      return `${formatNumber(prcentage)}`;
    }
  };
  return (
    <Container className={className}>
      <Title>Global search volume&nbsp;&nbsp; <Tooltip title={<TooltipDescriptionWrapper>
        The global search volume for a keyword is the average number of times per month that people search for that keyword across all countries in our database.
      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}><FontAwesomeIcon color={'black'} icon={faCircleInfo}/></Tooltip></Title>
      {/* {false ? (
        <div>
          <SkeletonRingLoader/>
        </div>
      ) : ( */}
      <>
        <CountryList>
          {loadingSvCountriesDetails ?
            <div style={{padding: '38px 50px'}}>
              <SkeletonRingLoader />
            </div> : (!loadingSvCountriesDetails && getSvTopSortCountries?.length) ? getSvTopSortCountries?.map(({countryCode, searchVolume}) => (
              <CountryItem value={getTrafficPercentage(searchVolume)} key={countryCode}>
                <><div style={{display: 'flex', alignItems: 'center'}}>
                  {countryCode == '' ? <>
                    <Globe width={12} />&nbsp;
                    <CountryName>
                  Worldwide
                    </CountryName>
                  </> : <>
                    <span style={{width: '24px'}}>{countryFlag(countryCode?.toUpperCase(), '12px')}</span>
                    <CountryName>
                      {(getSpecificCountryByCode(countryCode.toUpperCase())) ? (getSpecificCountryByCode(countryCode.toUpperCase()).name) : countryCode.toUpperCase()}
                    </CountryName>
                  </>}
                </div><CountryName>
                  <div style={{display: 'flex', alignItems: 'base-line'}}>
                    <div style={{marginRight: '10px'}}>{searchVolume ? formatLargeNumber(searchVolume, 1)?.toString()?.replace('.0', '') : '0'}</div>
                    <GrayText>{`${getTrafficPercentage(searchVolume)}%`}</GrayText>
                  </div>
                </CountryName></>
              </CountryItem>
            )) :
              <EmptyStateKeDetail imgText={'/img/backgroundfasearch.svg'} icon={true} text={'Data is unavailable or missing.'}/>

          }
        </CountryList>
      </>
    </Container>
  );
},
);

const Container = styled.div`
  padding: 20px 20px 20px 25px;
  height: 100%;
  position: relative;
  width: 30%;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
`;
const Title = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #121212;
`;
const CountryName = styled.span`
  font-weight: 400;
  font-size: 14;
  line-height: 17px;
  margin: 6px 8px;
`;
const CountryList = styled.div<{value?: any}>`
  padding: 0 5px 0 0 !important;
  max-height: 211px;
  overflow-y: auto;
  margin-top: 9px;
  position: relative;
  &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
`;

const CountryItem = styled.div<{value?: string | Number}>`
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  list-style: none;
  padding: 1px 0 !important;
  display: flex;
  justify-content: space-between;
  position: relative;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: ${p => `${p.value}%`};
    height: 31px;
    background-color: #FF853626;
  }

`;
const TooltipDescriptionWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #121212;
  padding: 5px;
`;
const GrayText = styled.div`
  color: #A3A4A4;
  font-size: 12px;
`;

